module.exports = __webpack_public_path__ + "img/companies.dd10e57c.png";